// The `]:[` mark + wordmark.

import { landingUrl } from "../lib/urls";

export function BrandMark({ size = 16 }: { size?: number }) {
  return (
    <img
      src="/brand/condense-mark.svg"
      alt=""
      width={size}
      height={size}
      style={{ display: "block", borderRadius: size * 0.2 }}
    />
  );
}

export function Brand() {
  return (
    <a
      href={landingUrl()}
      aria-label="condense.chat home"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        color: "inherit",
        textDecoration: "none",
      }}
    >
      <BrandMark size={26} />
      <span style={{ fontWeight: 600, letterSpacing: "-0.01em" }}>
        condense.chat
      </span>
    </a>
  );
}
